
import DefaultImage from "@/components/objects/public/attrs/image/items/DefaultImage.vue";
import { AttrsList, DesignExtra } from "@/utils/dto/objects.js";
import TheBlockHeader from "@/components/TheBlockHeader.vue";
import { adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: "ImageAttrDefault",
  components: { TheBlockHeader, DefaultImage },
  props: {
    items: {
      type: [Array, AttrsList],
      default: () => {
        return []
      }
    },
    objectId: {
      type: String
    },
    listInfo: {
      type: Object
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
  },
  data() {
    return {
      detail: false,
      openId: ""
    }
  },
  computed: {
    processedItems() {
      if (this.items.length === 1) {
        return this.items.map((item, index) => {
          return {
            data: item,
            notSmall: false
          }
        })
      }

      const COL_COUNT = this.items.length % 3 === 1 && this.items.length > 1 || this.items.length === 2 ? 2 : 3
      const LAST_MARKED_STARTS = this.items.length % COL_COUNT === 0 ? this.items.length - COL_COUNT : this.items.length - (this.items.length % COL_COUNT)

      return this.items.map((item, index) => {
        return {
          data: item,
          notOverlay: index + 1 > LAST_MARKED_STARTS
        }
      })
    },
    getImageType() {
      return this.items[0]?.image_type === 'image' ? 'images' : 'icons'
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'vistat';
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    getFirstBlockBg() {
      return this.design_extra?.first_block?.bg_color ?? this.getBgColor(0) ?? null;
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? null;
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    },
    blockBorderPalette() {
      if (this.design_extra?.block_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.block_border.palette)[0];
      }

      return null;
    },
  },
  methods: {
    getBlockBorderColor(index) {
      if (this.blockBorderPalette) {
        return [this.blockBorderPalette.main_color, ...this.blockBorderPalette.colors][index % [this.blockBorderPalette.main_color, ...this.blockBorderPalette.colors].length];
      } else if (this.design_extra?.block_border?.color) {
        return this.design_extra.block_border.color
      }

      return 'transparent';
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        return [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors][index % [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors].length];
      } else if (this.design_extra?.icon_border?.color) {
        return this.design_extra.icon_border.color
      }

      return 'transparent';
    },
    getBgColor(index) {
      if (this.bgPalette) {
        return [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color
      }

      return null;
    },
    getIconBgColor(index) {
      if (this.getIconGradientEnabled) {
        if (this.iconBgPalette) {
          const color = [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, white` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        } else if (this.design_extra?.icon_bg?.color) {
          const color = this.design_extra.icon_bg.color;
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, white` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        }
      } else {
        if (this.iconBgPalette) {
          return [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
        } else if (this.design_extra?.icon_bg?.color) {
          return this.design_extra.icon_bg.color;
        }
      }

      return null;
    },
  }
}
